import { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  amount,
  available,
  cancelled,
  customer,
  sold,
} from "../../assets/img/imgIndex";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const HomeScreen = () => {
  const [data, setData] = useState([
    {
      id: 1,
      title: "Total Sales",
      value: [
        { id: 1, name: "Total Sold", count: 0, img: sold },
        { id: 2, name: "Total Cancelled", count: 0, img: cancelled },
      ],
    },
    {
      id: 2,
      title: "Today Sales",
      value: [
        { id: 1, name: "Today Available", count: 0, img: available },
        { id: 2, name: "Today Sold", count: 0, img: sold },
        { id: 3, name: "Today Cancelled", count: 0, img: cancelled },
      ],
    },
    {
      id: 3,
      title: "Subscription Amount",
      value: [
        { id: 1, name: "Total Amount", count: 0, img: amount },
        { id: 2, name: "Today Amount", count: 0, img: amount },
      ],
    },
    {
      id: 4,
      title: "Customers",
      value: [
        { id: 1, name: "Total Customers", count: 0, img: customer },
        { id: 2, name: "Today Customers", count: 0, img: customer },
      ],
    },
    {
      id: 5,
      title: "Foods",
      value: [
        { id: 1, name: "Today Available", count: 0, img: available },
        { id: 2, name: "Today Expired", count: 0, img: amount },
        { id: 3, name: "Today Sold", count: 0, img: sold },
      ],
    },
  ]);

  const fetchData = async () => {
    let res_one = await get(URLS.DASHBOARD_TOTAL_SALES);
    let res_two = await get(URLS.DASHBOARD_TODAY_SALES);
    let res_three = await get(URLS.DASHBOARD_SUBSCRIPTION);
    let res_four = await get(URLS.DAHBOARD_CUSTOMERS);
    let res_five = await get(URLS.DASHBOARD_TODAY_FOODS);

    let obj = {
      total_sold: res_one?.total_sold,
      total_cancelled: res_one?.total_cancelled,

      today_available: res_two?.today_available,
      today_cancelled: res_two?.today_cancelled,
      today_sold: res_two?.today_sold,

      today_amount: res_three?.today_amount,
      total_amount: res_three?.total_amount,

      today_customers: res_four?.today_customers,
      total_customers: res_four?.total_customers,

      today_foods_available: res_five?.today_available,
      today_foods_expired: res_five?.today_expired,
      today_foods_sold: res_five?.today_sold,
    };

    setData((prev) =>
      prev.map((i) => {
        switch (i.id) {
          case 1:
            return {
              ...i,
              value: i.value.map((p) =>
                p.id === 1
                  ? { ...p, count: obj.total_sold }
                  : p.id === 2
                    ? { ...p, count: obj.total_cancelled }
                    : p,
              ),
            };

          case 2:
            return {
              ...i,
              value: i.value.map((p) =>
                p.id === 1
                  ? { ...p, count: obj.today_available }
                  : p.id === 2
                    ? { ...p, count: obj.today_sold }
                    : { ...p, count: obj.today_cancelled },
              ),
            };

          case 3:
            return {
              ...i,
              value: i.value.map((p) =>
                p.id === 1
                  ? { ...p, count: obj.total_amount }
                  : { ...p, count: obj.today_amount },
              ),
            };

          case 4:
            return {
              ...i,
              value: i.value.map((p) =>
                p.id === 1
                  ? { ...p, count: obj.total_customers }
                  : { ...p, count: obj.today_customers },
              ),
            };

          case 5:
            return {
              ...i,
              value: i.value.map((p) =>
                p.id === 1
                  ? { ...p, count: obj.today_foods_available }
                  : p.id === 2
                    ? { ...p, count: obj.today_foods_expired }
                    : { ...p, count: obj.today_foods_sold },
              ),
            };

          default:
            return i;
        }
      }),
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="dashboards">
      <PageHeader title="Dashboard" />

      <div className="dashboard-sections">
        {data.map((item) => (
          <div key={item.id} className="dash-section">
            {/* Title on top */}
            <p className="section-title">{item.title}</p>

            {/* Row of items */}
            <div className="section-row">
              {item.value.map((i) => (
                <div key={i.id} className="dash-item">
                  <div className="item-text">
                    <p className="item-count">{i.count}</p>
                    <p className="item-name">{i.name}</p>
                  </div>

                  <img src={i.img} alt={i.name} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeScreen;
